module.exports = __webpack_public_path__ + "img/second-4-opened.d5bf3242.webp";